<div class="head-wrapper display-flex">
  <div class="non-Pointer icon-div">
    <span class="helper"></span>
    <a class="navbar-brand">
    <img id="img-LandG" class="reflect-logo logo-resize" alt="" tabindex="0" src="{{LGLogoLink}}" /></a>
  </div>
  <div class="info-div display-flex">
    <div class="ref-div">
      @if (referenceNumber && enableRefno) {
        <span class="ref-no" id="referenceNumber">
          @if (referenceNumber?.quoteReferenceNumber && referenceNumber.applicationRefNumber === null) {
            <strong>{{contentData.yourRefNo}}</strong>{{referenceNumber?.quoteReferenceNumber}}
          }
          @if (referenceNumber.applicationRefNumber) {
            <strong>{{contentData.yourRefNo}}</strong>
            }{{referenceNumber.applicationRefNumber}}
          </span>
        }
      </div>
      <div class="help-div">
        <div class="help-text pad-right-30">
          <h6 class="call-customer-service" id="customer-services">
            {{contentData.custService}}
          </h6>
          <a href="tel:0800 008 3046"> <strong tabindex="0" (click)="toggleInfo()" (keyup.enter)="toggleInfo()" class="phone-number reflect-register" id="header_phoneNumber"
          [ngClass]="{'pointer': (router.url !== '/home/get-your-online-quote' && router.url !== '/home/you-will-need')}">{{contentData.phoneNo}}</strong></a>
          <small class="font-300 d-block" id="header_timeInfo">{{contentData.timeInfo}}</small>
          <small class="font-300 d-block" id="recordInfo">{{contentData.recordInfo}}</small>
        </div>

        <div class="Number_modal" #helpModal>
          @if (infoModalVisible) {
            <div class="info-modal clear-both ">
              <div class="need-help-text" aria-describedby="needHelpInfo">
                <small id="needHelpInfo" [attr.aria-label]="contentData.needHelpInfo">{{contentData.needHelpInfo}}</small>
                <div class="legal" id="quoteLineInfo" [attr.aria-label]="contentData.quoteLineInfo">{{contentData.quoteLineInfo}}
                </div>
                <small>
                  <a id="okayBtn" name="okayBtn" tabindex="0" (keyup.enter)="toggleInfo()" (click)="toggleInfo()" class="margin-left80 reflect"
                  aria-label="Okay">{{contentData.okayInfo}}</a>
                </small>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="login-div display-flex">
      @if (enableloginFeature) {
        <div class="login-button">
          <div id="firstNameBtn" (click)="dropdownToggle()" name="firstNameBtn" tabindex="0" class="button pointer name-flex">
            <span class="firstName-text" id="firstNameText">{{firstName}}</span>
            <i class="icon icon-chevron-down"></i>
          </div>
          @if (enableDropdown) {
            <div class="dropdown-content">
              <a (keyup.enter)="navigateToUpdateMyDetails()" (click)="navigateToUpdateMyDetails()">{{contentData.updateDetails}}</a>
              <a (keyup.enter)="navigateToQuoteResult()" (click)="navigateToQuoteResult()"> {{contentData.hereAreYourSavedQuotesText}} </a>
              <a class="only-mob" (keyup.enter)="logout()" (click)="logout()"> {{contentData.logoutText}} </a>
            </div>
          }
        </div>
      }
      @if (enableloginFeature) {
        <div class="logout-button">
          <span id="logoutBtn"  (click)="logout()" (keyup.enter)="logout()" role="link" tabindex="0" name="logoutBtn" class="custom-button logout-text pointer reflect">{{contentData.logoutText}}
          </span>
        </div>
      }
      @if (enableRegisterFeature && !enableloginFeature) {
        <span id="registerBtn" name="registerBtn" (keyup.enter)="register()" tabindex="0" role="link" (click)="register()" class="custom-button register-button pointer reflect-register"
          >
          {{contentData.registerText}}
        </span>
      }
    </div>
    <div class="contact-div" (click)="openPopupModal()">
      <img src="./assets/images/call-icon-mobile.svg" alt="LandG call" class="icon">
    </div>
  </div>
  <div class="blue-divider clear-both"></div>
  @if (referenceNumber && enableRefno) {
    <div class="mobile-quote-ref">
      <span  id="referenceNumber">
        @if (referenceNumber?.quoteReferenceNumber && referenceNumber.applicationRefNumber === null) {
          <strong>{{contentData.yourRefNo}}</strong>{{referenceNumber?.quoteReferenceNumber}}
        }
        @if (referenceNumber.applicationRefNumber) {
          <strong>{{contentData.yourRefNo}}</strong>
          }{{referenceNumber.applicationRefNumber}}
        </span>
      </div>
    }
    @if (infoModalVisible) {
      <div class="height-149"></div>
    }
    @if (displayAlert) {
      <app-modal-option [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()"></app-modal-option>
    }
    @if (isLocked) {
      <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()" (primaryBtnClick)="closeLockedModal()"
        [saveDataFlag]="false">
      </app-modal>
    }

    @if (openPopup) {
      <div class=window__container>
        <h6 class="mobile-call-customer-service" id="customer-services">
          {{contentData.custService}}
        </h6>
        <a href="tel:0800 008 3046"> <strong tabindex="0" (click)="toggleInfo()" (keyup.enter)="toggleInfo()" class="mobile-phone-number reflect-register" id="header_phoneNumber"
        [ngClass]="{'pointer': (router.url !== '/home/get-your-online-quote' && router.url !== '/home/you-will-need')}">{{contentData.phoneNo}}</strong></a>
        <small class="mobile-timeInfo d-block font-500" id="header_timeInfo">{{contentData.timeInfo}}</small>
        <small class="mobile-recordInfo font-300 d-block" id="recordInfo">{{contentData.recordInfo}}</small>
        <div class="mobile-line"></div>
      </div>
    }